import * as React from "react"

import { cn } from "@/lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
	({ className, type, ...props }, ref) => {
		return (
			<input
				type={type}
				data-slot="input"
				className={cn(
					"file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground border-input flex h-12 w-full min-w-0 rounded-none border bg-transparent px-3 py-1 text-sm shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:border-none disabled:opacity-50 md:text-sm",
					"focus-visible:border-ring hover:border-ring",
					"aria-invalid:ring-destructive/20 aria-invalid:border-destructive",
					className,
				)}
				ref={ref}
				{...props}
			/>
		)
	},
)

Input.displayName = "Input"

export { Input }
